export const ADD_TRANSACTIONS = 'ADD_TRANSACTIONS';
export const REMOVE_TRANSACTIONS = 'REMOVE_TRANSACTIONS';
export const SET_TRANSACTIONS = 'SET_TRANSACTIONS';
export const RAISE_TRANSACTION_INQUIRY = 'RAISE_TRANSACTION_INQUIRY';
export const SET_TRANSACTION_SUMMARY = 'SET_TRANSACTION_SUMMARY';
